import { render, staticRenderFns } from "./TheTesti.vue?vue&type=template&id=3e17df97"
import script from "./TheTesti.vue?vue&type=script&lang=js"
export * from "./TheTesti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports